import React from 'react';
import Button from '@mui/material/Button';

const defaultNavStyle = {
	display: 'grid',
	width: '100%',
	marginTop: '1rem',
	gridTemplateColumns: '1fr 1fr',
	columnGap: '0.5rem'
}

const Navigation = ({
	index,
	sections,
	navigation = {},
	customNavigationColors,
	isLoading,
	style = {},
	next = () => { },
	previous = () => { },
	submit = () => { },
	canContinue,
	canSubmit,
	disabled
}) => {
	const {
		nextLabel = 'next',
		previousLabel = 'previous',
		submitLabel = 'submit'
	} = navigation;

	const showPrevious = index > 0;
	const showNext = index < sections.length - 1;
	const showSubmit = index === sections.length - 1;

	const previousButtonColors = {
		color: customNavigationColors?.text,
		backGround: customNavigationColors?.previous,
		"&:hover": {
			backgroundColor: customNavigationColors.previous,
			opacity: 0.8,
		},
	};

	const nextButtonColors = {
		color: customNavigationColors?.text,
		backGround: customNavigationColors?.next,
		"&:hover": {
			backgroundColor: customNavigationColors.next,
			opacity: 0.8,
		},
	};

	// should we show loading state on the submit button in case of pending actions?
	// always icon
	return (
		<div className="nf-navigation" style={{ ...defaultNavStyle, ...style }}>
			{showPrevious && (
				<Button
					disabled={isLoading}
					variant="outlined"
					onClick={previous}
					sx={{
						...((customNavigationColors.text ||
							customNavigationColors.previous) &&
							previousButtonColors),
					}}
				>{previousLabel}</Button>
			)}
			{!showPrevious && <div />}
			{showNext && <Button disabled={isLoading || !canContinue} variant="contained" onClick={next} sx={{ backgroundColor: customNavigationColors?.previous }}>{nextLabel}</Button>}
			{showSubmit && <Button disabled={isLoading || !canContinue || disabled} variant="contained" onClick={submit} sx={{ ...((customNavigationColors.text || customNavigationColors.next) && nextButtonColors) }}>{submitLabel}</Button>}
		</div>
	)
};

export default Navigation;
